<div
  class="text-center col-12"
  style="padding: 20px 0 30px 0"
  *ngIf="isLoading"
>
  <app-spinner></app-spinner>
</div>
<div *ngIf="!isLoading">
  <div class="container" *ngIf="verifyOffer == 1">
    <div class="col-12" style="padding: 20px 0 20px 0">
      <div style="text-align: end">
        <div class="text-center" style="padding: 20px 0 20px 0">
          <h1 style="font-size: 30px">
            <strong translate>components.verifyAccount.Hola </strong
            ><strong>{{ userData?.first_name }}</strong>
          </h1>
          <h2
            translate> components.verifyAccount.Para verificar
          </h2>
          <br />
          <button
            type="button"
            class="btn"
            style="background-color: #0074a7; color: white"
            (click)="validateUser()"
            translate
          >
            components.verifyAccount.Verificar cuenta
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="container" *ngIf="verifyOffer == 2">
    <div class="col-12" style="padding: 20px 0 20px 0">
      <div style="text-align: end">
        <div class="text-center" style="padding: 20px 0 20px 0">
          <br /><br />
          <h1 style="font-size: 30px">
            <strong translate>components.verifyAccount.Excelente </strong
            ><strong>{{ userData?.first_name }}!</strong>
          </h1>
          <h2 style="font-size: 30px">
            <strong translate>components.verifyAccount.text-verificada</strong>
          </h2>
          <br />
          <button
            *ngIf="redirectReference"
            type="button"
            class="btn"
            style="background-color: #0074a7; color: white"
            [routerLink]="[
              '/' + translateService.currentLang + '/invertir/propiedad/',
              redirectReference
            ]"
            translate
          >
            components.verifyAccount.Volver a la propiedad
          </button>
          <button
            *ngIf="!redirectReference"
            type="button"
            class="btn"
            style="background-color: #0074a7; color: white"
            [routerLink]="['/' + translateService.currentLang]"
            translate
          >
            components.verifyAccount.Volver
          </button>
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>

  <div class="container" *ngIf="verifyOffer == 3">
    <div class="col-12" style="padding: 20px 0 20px 0">
      <div style="text-align: end">
        <div class="text-center" style="padding: 20px 0 20px 0">
          <small style="font-size: 20px" translate
            >components.verifyAccount.text-link-roto</small
          >
          <br /><br />
          <h1 style="font-size: 30px">
            <strong translate>components.verifyAccount.title2</strong>
          </h1>
          <br />
          <button
            type="button"
            class="btn"
            style="background-color: #0074a7; color: white"
            [routerLink]="['/' + translateService.currentLang + '/ingresar']"
            translate
          >
            components.verifyAccount.text-button
          </button>
          <br />
          <br />
          <small style="color: #828282; font-size: 14.5px" translate>
            components.buyOptions.¿Tienes alguna duda?
          </small>
          <a
            [routerLink]="[
              '/' + translateService.currentLang + '/sobre-nosotros/contacto'
            ]"
            style="color: #0074a7"
            translate
            >components.buyOptions.preguntarle a un agente inviertis aquí</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
